import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { apiJson, authorizedFetch } from "../utils/fetch";
import { useSession } from "./session";
import type { UserResponse } from "../types";

export function useUser() {
  const { session, ready } = useSession();
  return useQuery({
    queryKey: ["user"],
    queryFn: () => apiJson<UserResponse>("/user"),
    enabled: ready && Boolean(session),
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });
}

export function useUpdateProfile() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { display_name?: string; avatar_url?: string | null; obscure_email?: boolean }) =>
      authorizedFetch("/user/profile", {
        method: "PATCH",
        body: JSON.stringify(body),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["user"] });
    },
  });
}

export function useRequestAccountDeletion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () =>
      apiJson<{ pending_deletion_at: string }>("/user/deletion", {
        method: "POST",
        body: JSON.stringify({}),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["user"] });
    },
  });
}

export function useCancelAccountDeletion() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () =>
      authorizedFetch("/user/deletion/cancel", {
        method: "POST",
        body: JSON.stringify({}),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["user"] });
    },
  });
}
